import employeePlaceholderImage from '../assets/img/employee-placeholder-essential.png'
import buildingPlaceholderImage from '../assets/img/building-placeholder-essential.png'
import equipmentPlaceholderImage from '../assets/img/equipment-placeholder-essential.jpg'
import roomPlaceholderImage from '../assets/img/room-placeholder-essential.png'
import moment from 'moment'
import queryString from 'query-string'

/**
 * Extracts message from the exception object. Maps particular error codes to end-user-friendly error messages.
 * Checks all possible exception properties.
 * @param {Error} exception from which the error message needs to be extracted.
 */
export const extractMessageFromException = exception => {
  if (exception === null) {
    return ''
  }

  if (exception.code && exception.code === 101) {
    return 'Network connection is not available'
  }

  if (exception.localizedMessage && exception.localizedMessage.length > 0) {
    return exception.localizedMessage
  }

  if (
    exception.message &&
    exception.message.length > 0 &&
    exception.message !== ' :: '
  ) {
    return exception.message
  }

  if (exception.details && exception.details.length > 0) {
    return exception.details
  }

  if (exception.pattern && exception.pattern.length > 0) {
    return exception.pattern
  }

  if (exception.genericMessage && exception.genericMessage.length > 0) {
    return exception.genericMessage
  }

  if (exception.description && exception.description.length > 0) {
    return exception.description
  }

  return 'Unknown Error'
}

export const getPlaceHolderImage = type => {
  let url = employeePlaceholderImage

  switch (type) {
    case 'employee':
      url = employeePlaceholderImage
      break

    case 'building':
      url = buildingPlaceholderImage
      break
    case 'equipment':
      url = equipmentPlaceholderImage
      break
    case 'room':
      url = roomPlaceholderImage
      break
  }

  return url
}

export const serviceRequestStatusColor = {
  REQUESTED: 'Purple',
  APPROVED: 'Green',
  SCHEDULED: 'Green',
  'IN PROGRESS': 'Green',
  COMPLETED: 'Blue',
  'COMPLETED-V': 'Blue',
  CLOSED: 'Blue',
  CREATED: 'Green',
  REJECTED: 'Red',
  STOPPED: 'Red',
  CANCELED: 'Red',
  'IN PROCESS-H': 'Red',
  'N/A': 'Purple'
}

/**
 * Return the culture info given the browser locale
 * @param locale
 * @returns {*|string}
 */
export const getCultureInfo = locale => {
  const cultureInfos = {
    en: 'en-US',
    it: 'it-IT',
    de: 'de-DE',
    fr: 'fr-FR',
    nl: 'nl-NL',
    es: 'es-ES',
    ch: 'zh-Hans',
    zh: 'zh-Hant',
    no: 'no-NO',
    nb: 'no-NO',
    nn: 'no-NO'
  }
  return cultureInfos[locale] || 'en-US'
}

export const sqlDateToDate = dateStr => moment(dateStr, 'YYYY-MM-DD').toDate()

/**
 * Adds the icon path to the url.
 * @param url
 * @returns {*}
 */
export const getIconUrl = url => {
  let iconUrl = url

  if (url) {
    let extensionIndex = url.lastIndexOf('.')

    if (extensionIndex !== -1) {
      iconUrl =
        url.substring(0, extensionIndex) +
        '-icon.' +
        url.substring(extensionIndex + 1)
    }

    return iconUrl
  }
}

/**
 * Checks if the servicerequest action URL has valid parameters
 * Parameters are valid if the eq_id parameter exists or if the bl_id, fl_id and rm_id p
 * parameters exist
 * @param params The query parameters
 * @returns {Boolean} true if valid
 */
const isValidQrUrl = ({params}) => {
  const {bl_id, fl_id, rm_id, eq_id} = params
  return eq_id || (bl_id && fl_id && rm_id)
}

/**
 * Decodes the URL query string
 * @param params The query string as obtained from window.location.search
 * @returns {Object}
 */
export const decodeUrlParameters = ({searchString, kioskId = null}) => {
  let queryParams = queryString.parse(searchString)
  let result = {type: kioskId ? 'KIOSK' : 'DASHBOARD'}

  // Check for the action queryString
  // Valid action values are servicerequest or servicecatalog
  const {action, bl_id, fl_id, rm_id, eq_id} = queryParams

  if (action && !kioskId) {
    if (action === 'servicerequest') {
      if (isValidQrUrl({params: queryParams})) {
        result.type = eq_id ? 'QR-EQ' : 'QR-ROOM'
        result.qrParameters = eq_id ? {eq_id} : {bl_id, fl_id, rm_id}
      } else {
        result.type = 'DASHBOARD'
      }
    }
    if (action === 'servicecatalog') {
      result.type = 'CATALOG'
    }
  }

  return result
}

export const isEmpty = obj =>
  Object.entries(obj).length === 0 && obj.constructor === Object
